// extracted by mini-css-extract-plugin
export default {"wrap-header":"Calender_wrap-header__J0Trb","txt-date":"Calender_txt-date__zSwkr","txt-time":"Calender_txt-time__fb0oU","wrap-calendar":"Calender_wrap-calendar__IblZV"};